// extracted by mini-css-extract-plugin
export default {"hideTooltip":"C9-z","fadeIn":"D9-z","delay":"E9-z","recommendedSizeTooltip":"F9-z"};